import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import adminApi from "@/lib/admin-api";

const AdminAuthContext = createContext(undefined);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("cravve-admin-token");
    if (!token) { setAdmin(null); setLoading(false); return; }
    try {
      const { data } = await adminApi.get("/me");
      setAdmin(data);
    } catch {
      localStorage.removeItem("cravve-admin-token");
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const signin = async (email, password) => {
    const { data } = await adminApi.post("/auth/signin", { email, password });
    localStorage.setItem("cravve-admin-token", data.token);
    setAdmin(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("cravve-admin-token");
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, signin, logout, refresh, isAuthenticated: !!admin }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used within AdminAuthProvider");
  return ctx;
}
